$(document).ready(function () {
  $(".close-modal-x").on("click", function () {
    $("#submitRequest").hide();
  });

  // Proveriti da li postoji tarife-container za karusel
  if (
    !$("#tarife-container--carousel").length &&
    !$(".tarife-container--carousel--top-actions").length
  ) {
    return;
  }

  $(".more-info").on("click", function () {
    $(".popup")
      .removeClass("more-info-popup-open-left", "more-info-popup-close")
      .addClass("more-info-popup-close");
    let popup = $(this).parents(".bonus").siblings(".popup");

    $("body").off("click");
    setTimeout(function () {
      $("body")
        .not(".popup")
        .on("click", function (e) {
          $(popup).attr("class", "more-info-popup-close popup");
        });
    }, 500);

    if ($(popup).data("index") == 3) {
      $(popup).addClass("more-info-popup-open-left");
    } else {
      $(popup).addClass("more-info-popup-open");
    }
    $(popup).removeClass("more-info-popup-close");
  });

  $(".close-popup").on("click", function (e) {
    $(".popup")
      .removeClass("more-info-popup-open-left", "more-info-popup-close")
      .addClass("more-info-popup-close");
  });

  $slickchooseus = false;
  function chooseus_Slider() {
    if ($(window).width() < 1250) {
      if (!$slickchooseus) {
        // Inicijalizujemo karusel za standardni tarife-container
        $(".cards-section-carousel").slick({
          dots: false,
          prevArrow: false,
          nextArrow: false,
          centerMode: false,
          centerPadding: "60px",
          infinite: false,
          slidesToShow: 3,
          autoplay: true,
          autoplaySpeed: 1500,
          responsive: [
            {
              breakpoint: 850,
              settings: {
                arrows: false,
                variableWidth: true,
                centerMode: true,
                centerPadding: "40px",
                slidesToShow: 1,
              },
            },
            {
              breakpoint: 480,
              settings: {
                arrows: false,
                centerMode: true,
                centerPadding: "40px",
                slidesToShow: 1,
              },
            },
          ],
        });
        $slickchooseus = true;
      }
    } else if ($(window).width() > 1249) {
      if ($slickchooseus) {
        $(".cards-section-carousel").slick("unslick");
        $slickchooseus = false;
      }
    }
  }

  $(function () {
    chooseus_Slider();
    $(window).resize(function () {
      chooseus_Slider();
    });

    // Potpuno nezavisna inicijalizacija top-actions karusela
    // Ovo je potpuno izolovan kod koji neće uticati na druge karusele na sajtu
    setTimeout(function() {
      // Proveravamo samo jednom kada je DOM spreman
      if ($(".top-actions-carousel-unique").length) {
        // Sigurnosna provera - uništava postojeću inicijalizaciju ako postoji
        if ($(".top-actions-carousel-unique").hasClass("slick-initialized")) {
          $(".top-actions-carousel-unique").slick("unslick");
        }
        
        // Konfiguracija specificno optimizovana za top-actions karusel
        $(".top-actions-carousel-unique").slick({
          dots: false,
          prevArrow: "<button type='button' class='slick-prev'><img src='/images/icons/tarife-arrow-down.svg' alt='arrow'/></button>",
          nextArrow: "<button type='button' class='slick-next'><img src='/images/icons/tarife-arrow-down.svg' alt='arrow'/></button>",
          slidesToShow: 3,
          slidesToScroll: 1,
          speed: 300,
          infinite: false,
          autoplay: false,
          draggable: false,
          swipe: true,
          touchMove: true,
          centerMode: false,
          variableWidth: false,
          // Posebne postavke za responsive prikaz
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                arrows: true,
                infinite: false,
                autoplay: false,
              }
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                infinite: false,
                autoplay: false,
                draggable: false,
                adaptiveHeight: true
              }
            }
          ]
        });
        
        // Dodatni event handler za popravku prikaza nakon resize-a
        $(window).on('resize', function() {
          if ($(".top-actions-carousel-unique").hasClass("slick-initialized")) {
            setTimeout(function() {
              $(".top-actions-carousel-unique").slick('setPosition');
            }, 200);
          }
        });
      }
    }, 100);
  });

  $(".news-carousel").slick({
    // dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    prevArrow:
      "<button type='button' class='slick-prev pull-left'><img src='/images/icons/tarife-arrow-down.svg' alt='arrow'/></button>",
    nextArrow:
      "<button type='button' class='slick-next pull-right'><img src='/images/icons/tarife-arrow-down.svg' alt='arrow'/></button>",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          arrows: true,
          // dots: true
        },
      },
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: false,
          centerMode: true,
          // infinite: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          centerMode: true,
          infinite: false,
        },
      },
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ],
  });

  const faqItems = document.querySelectorAll(".faq-box");

  faqItems.forEach((item) =>
    item.addEventListener("click", () => {
      const answer = item.querySelector(".answer");
      const arrow = item.querySelector(".img_arrow");

      if (answer.style.maxHeight !== "100vh") {
        answer.style.maxHeight = "0vh";
        arrow.style.transform = "rotate(0deg)";
      } else {
        answer.style.maxHeight = "100vh";
        arrow.style.transform = "rotate(180deg)";
      }
    })
  );

  $(".cards-section-carousel").on("click", ".business-buy", function (e) {
    e.preventDefault();
    let tariffName = $(this).data("tariff-name");
    $("#tariff").val(tariffName);
    $($(this).data("target")).show();
  });
});
